import { hasShowDetails } from 'utils/showDetails';

const getPriceByPlan = (
  beneficiaryPlan: any,
  simulatorSharePriceUnit: any,
  includeAllUnits: boolean
) => {
  const totalUnits = includeAllUnits
    ? beneficiaryPlan?.sharesCount?.future || 0
    : beneficiaryPlan?.vestedUnits || 0;

  const isFixedPrice = !!(
    beneficiaryPlan?.customConditions?.isFixedPrice ||
    beneficiaryPlan?.planData?.isFixedPrice
  );

  const sharePrice =
    beneficiaryPlan?.customConditions?.sharePrice ||
    beneficiaryPlan?.planData?.sharePrice ||
    0;

  const totalSalePrice = totalUnits * simulatorSharePriceUnit || 0;

  const totalInitialPrice = isFixedPrice ? sharePrice : totalUnits * sharePrice;

  const totalPrice = totalSalePrice - totalInitialPrice;

  const finalPrice = totalPrice;

  return finalPrice;
};

export default getPriceByPlan;
